import React from 'react';
import Link from '@teetsh/app/src/components/Link';
import { buttonRootStyle } from '@teetsh/app/src/components/Buttons/Button';
import { BaseButtonProps } from './BaseButtonProps';
import clsx from 'clsx';
import tw from 'twin.macro';
import { ButtonContent } from '@teetsh/app/src/components/Buttons/ButtonContent';

interface CProps {
  children?: React.ReactNode;
  className?: string;
  'aria-label'?: string;
  forceUpdate?: boolean;
  id?: string;
  to: string;
}

export type Props = CProps & BaseButtonProps;

export default function ButtonLink(props: Props) {
  const {
    forceUpdate,
    className,
    to,
    active,
    alignText,
    disabled,
    loading,
    fill,
    intent,
    large,
    minimal,
    outlined,
    small,
    extralarge,
    iconSize,
    icon,
    rightIcon,
    innerRef,
    ...rest
  } = props;
  const buttonStyle = buttonRootStyle({
    active,
    alignText,
    disabled,
    extralarge,
    fill,
    hasChildren: !!props.children,
    intent,
    large,
    loading,
    minimal,
    outlined,
    small,
  });

  if (disabled) {
    return (
      <span css={buttonStyle} className={clsx('tsh-button', className)}>
        <ButtonContent {...props} />
      </span>
    );
  }

  return (
    <Link
      css={[tw`no-underline!`, buttonStyle]}
      forceUpdate={forceUpdate}
      to={to}
      {...rest}
      className={clsx('tsh-button', className)}
    >
      <ButtonContent {...props} />
    </Link>
  );
}
